module.exports = __webpack_public_path__ + "static/00012.51c6dd50.jpg";